<script setup lang="ts">
import type { Agent, AgentOnList } from '@@/shared/agent/types';

defineProps<{
  agent: Agent | AgentOnList
}>();
</script>

<template>
  <div>
    <AgentTinyPreview :agent />
  </div>
</template>
